module.exports = __webpack_public_path__ + "static/img/bf.ab8408e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/mipmap-xxxhdpi/bf.png
// module id = JKKB
// module chunks = 18